import React, { useEffect } from 'react';
import { TouchableOpacity, View } from 'react-native';
import {
  ContinueToContractButton,
  DefaultScreenContainer,
  InsuranceCardBenefit,
  OfferBanner,
  Text,
} from '~/components';
import useAppNavigation from '~/hooks/useAppNavigation';
import { isWeb } from '~/utils/device';

import MoneyBillSVG from '~/assets/svgs/money-bill.svg';
import ProtectionShiledSVG from '~/assets/svgs/protection-shield.svg';
import LucklyCloverSVG from '~/assets/svgs/luckly-clover.svg';

import BannerImg from '~/assets/img/banners/income-protection-banner.png';
import BannerImgDesk from '~/assets/img/banners/income-protection-banner-desk.png';
import type { Benefit } from '~/components/InsuranceCardBenefit';
import GeneralInfoFooter from '../components/GeneralInfoFooter';
import { useUserInfoStore } from '~/stores/userInfo';
import { journeyLogUseCase } from '~/useCases/PSF/JourneyLogUseCase';
import { useSalesFunnel } from '~/stores';

const INSURANCE_TYPE = 'income-protection';
const CONTRACT_SCREEN = 'MarisaServicos_IncomeProtectionContract';

const BENEFITS: Benefit[] = [
  {
    icon: ProtectionShiledSVG,
    title: 'Proteja-se de imprevistos',
    description: (
      <Text className="text-sm mt-0">
        Em caso de desemprego involuntário, você receberá até 4 parcelas de até{' '}
        <Text className="text-primary-600 font-medium">R$ 500,00</Text>.
        Cobertura com carência de 30 dias.
      </Text>
    ),
  },
  {
    icon: MoneyBillSVG,
    title: 'Indenização',
    description: (
      <Text className="text-sm">
        Comodidade de auxiliar no pagamento de dívidas com a indenização de{' '}
        <Text className="text-primary-600 font-medium">R$ 2.000,00</Text> em
        caso de invalidez permanente total por acidente ou morte.
      </Text>
    ),
  },
  {
    icon: LucklyCloverSVG,
    title: 'Concorra a prêmios',
    description: (
      <Text className="text-sm">
        Você concorre toda semana à{' '}
        <Text className="text-primary-600 font-medium">R$ 5.000,00</Text> pela
        loteria federal. Valor líquido de IR.
      </Text>
    ),
  },
];

const IncomeProtectionDetails: React.FC = () => {
  const { setOptions, goBack } = useAppNavigation();
  const { init } = useSalesFunnel();

  const id = useUserInfoStore((state) => state.user?.id);

  useEffect(() => {
    setOptions({
      // headerTitle: () => <Logo onPress={() => setModalVisible(true)} />,
    });
  }, [setOptions]);

  useEffect(() => {
    init('income-protection');
    if (id) {
      journeyLogUseCase(useUserInfoStore.getState().user, 'PERDARENDA');
    }
  }, [id, init]);

  return (
    <DefaultScreenContainer>
      <OfferBanner
        hireInsurance={{
          showButton: true,
          type: INSURANCE_TYPE,
          redirectScreen: CONTRACT_SCREEN,
        }}
        images={{
          mobile: BannerImg,
          web: { banner: BannerImgDesk },
        }}
        insuranceName="Proteção
        Perda de Renda"
        insuranceDetail="Você preparada quando for pega de surpresa."
      />

      <View className="px-6">
        <View className="md:items-center md:justify-center items-start justify-start">
          <Text className="mt-6 sm:mt-16 text-gray-700 text-[22px]">
            O que é o Proteção Perda de Renda?
          </Text>

          <Text className="mt-4 text-gray-400 md:text-center text-[16px] leading-6">
            O microsseguro Proteção Perda de Renda não te deixará na mão em
            situação de desemprego involuntário, auxiliando em até 4 parcelas
            indenizatórias.
          </Text>
        </View>

        {isWeb && (
          <View className="mt-10 mb-2 bg-gray-100 h-[1px] invisible md:visible" />
        )}

        <Text className="mt-8 text-xl text-gray-700 md:items-center md:justify-center md:text-center md:mb-6">
          Conheça os benefícios:
        </Text>

        <View className="lg:flex-row lg:justify-between">
          {BENEFITS.map((benefit, index) => (
            <InsuranceCardBenefit
              data={benefit}
              type="protection"
              key={index}
            />
          ))}
        </View>

        <GeneralInfoFooter className="mb-8 mt-2" />

        <View className="items-center justify-center py-4 bg-feedback-neutral-bkg rounded-lg mb-7">
          <Text className="text-secondary-800 text-sm">
            Tudo isso por R$ <Text className="text-xl font-medium">17,99</Text>
            /mês
          </Text>

          <Text className="text-secondary-800 text-xs mt-2">
            Apenas R$ 0,60 por dia!
          </Text>
        </View>
      </View>
      <View className="py-4 px-6 items-center justify-center lg:mx-auto lg:w-[328px]">
        <ContinueToContractButton
          type={INSURANCE_TYPE}
          buttonLabel="Contratar Seguro"
          navigateTo={CONTRACT_SCREEN}
        />

        {isWeb && (
          <TouchableOpacity onPress={() => goBack()}>
            <Text className="text-primary-600 uppercase font-medium mt-4 text-xs">
              Voltar
            </Text>
          </TouchableOpacity>
        )}
      </View>
    </DefaultScreenContainer>
  );
};

export default IncomeProtectionDetails;
